<template>
  <div class="no-header">
    <main>
      <slot />
    </main>
  </div>
</template>

<script>
export default {
  name: 'NoHeader',
  components: {
  },
};
</script>
